import React from "react";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { MdWarningAmber } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function InvalidToken() {
  const navigate = useNavigate();
  return (
    <Container className="mainContent text-center">
      <MdWarningAmber size="50px" />
      <h1 className="my-3">Invalid Token</h1>
      <p>
        Token is missing.{" "}
      </p>
      {/* <Button onClick={}>Login</Button> */}
    </Container>
  );
}

export default InvalidToken;
